export function isVacationContract(contract) {
  const value =
    contract.contractType ??
    contract.typeContrat ??
    contract.TypeContrat ??
    contract.service;
  return (
    String(value ?? "")
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .trim()
      .toLowerCase() === "vacation"
  );
}
